const stripApiSuffix = (base) => String(base || "").replace(/\/api\/?$/, "");

const resolveApiBase = () => {
  const craBase =
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || "";
  let viteBase = "";
  try {
    if (typeof import.meta !== "undefined" && import.meta.env) {
      viteBase = import.meta.env.VITE_API_BASE_URL || "";
    }
  } catch (_) {
    // ignore non-vite builds
  }
  const envBase = craBase || viteBase || "";
  const cleaned = stripApiSuffix(envBase);
  if (typeof window === "undefined") {
    return cleaned || "";
  }
  const fallback = window.location.origin || "";
  if (!cleaned) return fallback;
  return cleaned;
};

const API_BASE = resolveApiBase();

const apiBasePath = () => {
  if (!API_BASE || typeof window === "undefined") return "";
  try {
    return new URL(API_BASE, window.location.origin).pathname.replace(/\/$/, "");
  } catch (_) {
    return "";
  }
};

const buildVariantUrl = (path, options = {}) => {
  const width = Number(options.width || options.w || 0);
  if (!width || !path.startsWith("/uploads/")) return "";

  const params = new URLSearchParams({
    src: path,
    w: String(Math.round(width)),
  });

  const height = Number(options.height || options.h || 0);
  if (height) params.set("h", String(Math.round(height)));
  if (options.fit) params.set("fit", options.fit);
  if (options.quality || options.q) params.set("q", String(options.quality || options.q));
  if (options.format) params.set("format", options.format);

  const base = API_BASE.replace(/\/$/, "");
  return `${base}/api/media/variant?${params.toString()}`;
};

const REMOTE_IMAGE_PROXY_HOSTS = new Set([
  "d4b28jbnqso5g.cloudfront.net",
]);

const buildRemoteVariantUrl = (raw, options = {}) => {
  const width = Number(options.width || options.w || 0);
  if (!width || !options.proxyRemote) return "";
  try {
    const url = new URL(raw);
    if (!REMOTE_IMAGE_PROXY_HOSTS.has(url.hostname)) return "";
    const params = new URLSearchParams({
      src: url.toString(),
      w: String(Math.round(width)),
    });
    const height = Number(options.height || options.h || 0);
    if (height) params.set("h", String(Math.round(height)));
    if (options.fit) params.set("fit", options.fit);
    if (options.quality || options.q) params.set("q", String(options.quality || options.q));
    if (options.format) params.set("format", options.format);
    const base = API_BASE.replace(/\/$/, "");
    return `${base}/api/media/remote-variant?${params.toString()}`;
  } catch (_) {
    return "";
  }
};

export const resolveMediaUrl = (value, options = {}) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^data:/i.test(raw) || /^blob:/i.test(raw)) return raw;
  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw);
      const base = API_BASE ? new URL(API_BASE, window.location.origin) : null;
      const basePath = apiBasePath();
      const uploadPath =
        url.pathname.startsWith("/uploads/")
          ? url.pathname
          : basePath && url.pathname.startsWith(`${basePath}/uploads/`)
            ? url.pathname.slice(basePath.length)
            : "";
      const isLocalUpload =
        uploadPath &&
        (!base ||
          url.origin === base.origin ||
          url.hostname === "api.homevilas.com" ||
          url.hostname === "localhost" ||
          url.hostname === "127.0.0.1");
      if (isLocalUpload) {
        const variantUrl = buildVariantUrl(uploadPath, options);
        if (variantUrl) return variantUrl;
        const publicBase = base?.origin || API_BASE.replace(/\/$/, "");
        return `${publicBase}${uploadPath}`;
      }
      const remoteVariantUrl = buildRemoteVariantUrl(raw, options);
      if (remoteVariantUrl) return remoteVariantUrl;
    } catch (_) {
      // keep original URL
    }
    return raw;
  }
  if (raw.startsWith("/landing/") || raw.startsWith("landing/")) {
    return raw.startsWith("/") ? raw : `/${raw}`;
  }

  let path = raw.replace(/\\/g, "/");
  const basePath = apiBasePath();
  if (basePath && path.startsWith(`${basePath}/uploads/`)) {
    path = path.slice(basePath.length);
  }
  if (path.startsWith("uploads/")) path = `/${path}`;
  if (path.startsWith("/uploads/")) {
    const variantUrl = buildVariantUrl(path, options);
    if (variantUrl) return variantUrl;
    const base = API_BASE.replace(/\/$/, "");
    return `${base}${path}`;
  }

  return path;
};


